<script setup>
import GuidanceComponent from "../../layouts/components/Notice.vue";
import HeadlineComponent from "./Headline.vue";
import PageTransition from "./PageTransition.vue";
import {inject} from "vue";

const props = defineProps({
    title: String,
    message: String,
    selections: Array,
    image: {
        type: String,
        required: false,
        default: null
    },
    inputValues: Object,
    sendMailAddress: String,
    showConfirm: {
        type: Boolean,
        required: false,
        default: true
    },
    previousIndex: Number,
    isTopReturn: Boolean
});
function getPreviousIndex() {
    if (!props.previousIndex) {
        return index - 1;
    }
    if (!isNaN(props.previousIndex)) {
        return props.previousIndex;
    }
    return props.previousIndex.value;
}

const REISSUE_MAIL_ADDRESS = inject("REISSUE_MAIL_ADDRESS");
const SUBJECT = '';
const index = inject('index');

function getMessage() {
    return "※メールが届かない場合は以下をご確認ください" + "\n" +
"・「" + REISSUE_MAIL_ADDRESS +"」のドメインからメールが届く設定になっているか" + "\n" +
"・迷惑メールフォルダに隔離されていないか";
}

</script>

<template>
    <div class="uk-margin-small-left uk-margin-small-right uk-flex-1">
        <div class="uk-flex uk-flex-column uk-height-1-1">
            <headline-component v-if="props.title" :title="props.title"/>
            <div>
                <a :href="'mailto:' + REISSUE_MAIL_ADDRESS">
                    <button class="uk-button uk-button-primary uk-border-rounded uk-margin-auto uk-width-auto"
                            @click="$emit('sendMail')">
                        空メールを送信する
                    </button>
                </a>
            </div>
            <div id="guidance-wrapper" class="uk-flex-1 uk-margin uk-flex uk-flex-column uk-overflow-auto">
                <Guidance-component v-if="showConfirm" class="uk-width-1-1" :message="getMessage()" style="overflow-y: scroll;"/>
                <div v-if="image" class="uk-margin-top">
                    <img :src="image" alt="image" class="uk-width-1-1"/>
                </div>
            </div>
            <page-transition
                @change-index="(index,key,value) => {$emit('changeIndex',index,key,value);}"
                @reset-input-value="(index) => {$emit('resetInputValue', index);}"
                :index="index"
                :previous-index="getPreviousIndex()"
                :next-index="null"
                :input-key="title"
                :value="null"
                :is-active-button="true"
                :selections="null"
                :is-top-return="isTopReturn">
            </page-transition>
        </div>
    </div>
</template>

<style scoped>
#guidance-wrapper {
    align-items: center;
}
</style>